import { gql } from "@apollo/client";

export const GET_JUSTIFICAR_MINUTA_GRILLA = gql`
    query GetListarJustificaciones($idDelegacion: Int!) {
        listarJustificaciones(idDelegacion: $idDelegacion) {
            idMinuta,
            cliente,
            codClienteSAP,
            modulo,
            cantidadConexion,
            precioTotal,
            codPacienteSAP,
            paciente,
            delegacion,            
            precioControl,
            fA,
            cotizado,
            estadoPrecioMinuta,
            estadoPrecioEvaluacion,
            idEvaluacion,
            precioDiario,
            fechaAlta,
            planCuidado,
            estadoMinuta,
            precioSAP,
            check,
            idJustificacionMinuta,
            idPaciente,
            idPendiente,
            codPlanSAP,
            idPlanCuidado,
            observaciones
        }
    }
`;

export const adaptJustificarMinutaGrilla = (minuta) => {
  return {
    idMinuta: minuta?.idMinuta,
    cliente: minuta?.cliente,
    codClienteSAP: minuta?.codClienteSAP,
    modulo: minuta?.modulo,
    cantidadConexion: minuta?.cantidadConexion,
    precioTotal: minuta?.precioTotal,
    codPacienteSAP: minuta?.codPacienteSAP,
    paciente: minuta?.paciente,
    delegacion: minuta?.delegacion,
    precioControl: minuta?.precioControl,
    fA: minuta?.fA,
    cotizado: minuta?.cotizado,
    estadoPrecioMinuta: minuta?.estadoPrecioMinuta,
    estadoPrecioEvaluacion: minuta?.estadoPrecioEvaluacion,
    idEvaluacion: minuta?.idEvaluacion,
    precioDiario: minuta?.precioDiario,
    fechaAlta: minuta?.fechaAlta,
    planCuidado: minuta?.planCuidado,
    estadoMinuta: minuta?.estadoMinuta,
    precioSAP: minuta?.precioSAP,
    check: minuta?.check,
    idJustificacionMinuta: minuta?.idJustificacionMinuta,
    idPaciente: minuta?.idPaciente,
    idPendiente: minuta?.idPendiente,
    codPlanSAP: minuta?.codPlanSAP,
    idPlanCuidado: minuta?.idPlanCuidado,
    observaciones: minuta?.observaciones
  };
};

export const adaptJustificarMinutaGrillaArray = (minutas) => {
  return structuredClone(minutas)?.
  map((minuta) => adaptJustificarMinutaGrilla(minuta));
};